"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle publications
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.publications = {
    initialize: function () {
        'use strict';
        $('a.publication-link').prop({
            'rel': 'contentbox',
            'href': function () {
                return $(this).attr('href');
            }
        });
    }
};
exports.default = {};
